import { inject, Injectable, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DeviceInfoService } from '@core/services/device-info.service';
import { AllDeviceInfo, MfaChallengeAction } from '@interfaces';
import {
  MfaActionVerificationModalComponent,
  MfaActionVerificationModalData,
  MfaActionVerificationModalResult,
} from './mfa-action-verification-modal.component';

@Injectable()
export class MfaActionVerificationModalService implements OnDestroy {
  private readonly dialog = inject(MatDialog);
  private readonly deviceInfoService = inject(DeviceInfoService);

  public dialogRef: MatDialogRef<MfaActionVerificationModalComponent, MfaActionVerificationModalResult>;
  public name = 'mfa-action-verification-modal';

  private destroy$ = new ReplaySubject<boolean>(1);

  public deviceInfo: AllDeviceInfo;
  private dialogWidth = '560px';
  private dialogHeight = 'auto';

  constructor() {
    this.deviceInfo = this.deviceInfoService.getInfo();
    this.deviceInfoService.infoEmitter.pipe(takeUntil(this.destroy$)).subscribe(info => {
      this.deviceInfo = info;
      this.setDialogDimensions();
    });

    this.setDialogDimensions();
  }

  public open<TAction extends MfaChallengeAction>(
    data: MfaActionVerificationModalData<TAction>
  ): MatDialogRef<MfaActionVerificationModalComponent, MfaActionVerificationModalResult<TAction>> {
    this.dialogRef = this.dialog.open(MfaActionVerificationModalComponent, {
      width: this.dialogWidth,
      maxWidth: this.dialogWidth,
      height: this.dialogHeight,
      panelClass: ['mfa-action-verification-modal'],
      autoFocus: false,
      data,
      id: this.name,
      backdropClass: this.name + '_backdrop',
    });

    return this.dialogRef as MatDialogRef<
      MfaActionVerificationModalComponent,
      MfaActionVerificationModalResult<TAction>
    >;
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  private setDialogDimensions(): void {
    if (this.deviceInfo?.deviceTypeDetected === 'PHONE') {
      this.dialogWidth = '95vw';
      this.dialogHeight = '95dvh';
      return;
    }

    this.dialogWidth = '560px';
    this.dialogHeight = 'auto';
  }
}
